import { Link } from 'react-router-dom';

// All partner logos for scrolling band
// ORDER: Metro Club → Leddis → Momento → Fairflow → fromnow → Nina → Urban Echoes → Fairtix
const SPONSOR_LOGOS = [
  { 
    name: 'METRO CLUB', 
    id: 'metro-club', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/m33n80fc_metro%20club.png',
    height: '40px',
  },
  { 
    name: 'LEDDIS', 
    id: 'leddis', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/xu85l1hn_LEDDIS%20logo.png',
    height: '36px',
  },
  { 
    name: 'MOMENTO', 
    id: 'momento', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/fvnj7on3_Typo%20Momento%20white.png',
    height: '34px',
  },
  { 
    name: 'FAIRFLOW', 
    id: 'fairflow', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/znxi8qvo_FAIRFLOW%20FINAL%20LOGO.png',
    height: '36px',
  },
  { 
    name: 'FROMNOW', 
    id: 'fromnow', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/j19rnga9_fromnow.png',
    height: '34px',
  },
  { 
    name: 'NINA', 
    id: 'nina', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/od3ttswz_Nina%20nina.png',
    height: '30px',
  },
  { 
    name: 'URBAN ECHOES', 
    id: 'urban-echoes', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/9kmwo9xk_Urban%20Echoes%202grispng-04.png',
    height: '34px',
  },
  { 
    name: 'FAIRTIX', 
    id: 'fairtix', 
    logo: 'https://customer-assets.emergentagent.com/job_e3d607ae-98b3-4cfa-9c06-6cf7ab967614/artifacts/y9gb8rqs_fairtix.png',
    height: '32px',
  },
];

export default function SponsorReel() {
  // Duplicate the list for seamless infinite scroll
  const sponsors = [...SPONSOR_LOGOS, ...SPONSOR_LOGOS];

  return (
    <div
      data-testid="sponsor-reel"
      style={{
        width: '100%',
        overflow: 'hidden',
        padding: '14px 0',
        borderTop: '1px solid rgba(240,244,248,0.05)',
        borderBottom: '1px solid rgba(240,244,248,0.05)',
        background: 'rgba(5,10,20,0.35)',
      }}
    >
      <div
        className="sponsor-reel-inner"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0',
          animation: 'scroll-sponsors 45s linear infinite',
          width: 'max-content',
          willChange: 'transform',
        }}
      >
        {sponsors.map((sponsor, index) => (
          <Link
            key={`${sponsor.id}-${index}`}
            to={`/partners#${sponsor.id}`}
            data-testid={`sponsor-link-${sponsor.id}-${index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              padding: '0 20px',
              height: '44px',
              flexShrink: 0,
            }}
          >
            {sponsor.logo ? (
              <img
                src={sponsor.logo}
                alt={sponsor.name}
                style={{
                  height: `calc(${sponsor.height || '32px'} * 0.85)`,
                  maxWidth: '100px',
                  objectFit: 'contain',
                  opacity: 0.55,
                  filter: 'grayscale(0.15)',
                  transition: 'opacity 0.3s, filter 0.3s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.9';
                  e.currentTarget.style.filter = 'grayscale(0)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '0.55';
                  e.currentTarget.style.filter = 'grayscale(0.15)';
                }}
              />
            ) : (
              <span
                style={{
                  fontFamily: 'Space Grotesk, sans-serif',
                  fontSize: '10px',
                  fontWeight: 500,
                  letterSpacing: '0.18em',
                  textTransform: 'uppercase',
                  color: 'var(--vvs-muted)',
                  opacity: 0.45,
                  transition: 'opacity 0.3s, color 0.3s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.85';
                  e.currentTarget.style.color = 'var(--vvs-cyan)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '0.45';
                  e.currentTarget.style.color = 'var(--vvs-muted)';
                }}
              >
                {sponsor.name}
              </span>
            )}
            <span
              style={{
                margin: '0 12px',
                color: 'rgba(148,163,184,0.2)',
                fontFamily: 'Space Grotesk',
                fontSize: '10px',
              }}
            >
              //
            </span>
          </Link>
        ))}
      </div>

      {/* CSS Animation - slower and smoother on mobile */}
      <style>
        {`
          @keyframes scroll-sponsors {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          
          .sponsor-reel-inner:hover {
            animation-play-state: paused;
          }
          
          @media (max-width: 768px) {
            .sponsor-reel-inner {
              animation-duration: 55s !important;
            }
          }
        `}
      </style>
    </div>
  );
}
